import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './index.css';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import Products from './pages/Products';
import Promotions from './pages/Promotions';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import Cart from './pages/Panier';
import Footer from './components/Footer';
import { CartProvider, useCart } from './hooks/cart';
import { WishlistProvider } from './hooks/wishlist';
import { ToastContainer } from 'react-toastify';
import Dashboard from './pages/Admin/Dashboard';
import Authentication from './pages/Admin/Authentication';
import ForgotPassword from './pages/Admin/ForgotPassword';
import ResetPassword from './pages/Admin/ResetPassword';
import CartModal from './components/CartModal';
import Product from './pages/Product';
import Nouveaute from './pages/Nouveaute';
import OrderSuccess from './pages/OrderSucess';
import Wishlist from './pages/Wishlist';
import './i18n/config';
import ScrollToTop from './components/ScrollToTop';

function AppRoutes() {
  const location = useLocation();
  const { isModalOpen, closeModal, cart, updateQuantity } = useCart();

  const isDashboard = location.pathname.startsWith('/admin/dashboard');

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {!isDashboard && <Navbar />}
      <ScrollToTop/>
      <Routes>
        <Route
          path="/"
          element={<main className="main-content"><Home /></main>}
        />
        <Route
          path="/products"
          element={<main className="main-content"><Products /></main>}
        />
        <Route
          path="/products/:categoryTitle"
          element={<main className="main-content"><Products /></main>}
        />
        <Route
          path="/products/:categoryTitle/:subCategoryTitle"
          element={<main className="main-content"><Products /></main>}
        />
        <Route
          path="/product/:categoryTitle/:subCategoryTitle/:productTitle"
          element={<main className="main-content"><Product /></main>}
        />
        <Route
          path="/usedscales"
          element={<main className="main-content"><Promotions /></main>}
        />
        <Route
          path="/nouveaute"
          element={<main className="main-content"><Nouveaute /></main>}
        />
        <Route
          path="/aboutus"
          element={<main className="main-content"><AboutUs /></main>}
        />
        <Route
          path="/contact"
          element={<main className="main-content"><Contact /></main>}
        />
        <Route
          path="/panier"
          element={<main className="main-content"><Cart /></main>}
        />

        <Route
          path="/wishlist"
          element={<main className="main-content"><Wishlist /></main>}
        />

        <Route
          path="/order-success"
          element={<main className="main-content"><OrderSuccess /></main>}
        />

        <Route path="/admin/login" element={<Authentication />} />
        <Route path="/admin/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin/reset-password" element={<ResetPassword />} />
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <CartModal isOpen={isModalOpen} cart={cart} onClose={closeModal} updateQuantity={updateQuantity} />
    </>
  );
}

function App() {
  return (
    <CartProvider>
      <WishlistProvider>
        <Router>
          <AppLayoutWrapper />
        </Router>
      </WishlistProvider>
    </CartProvider>
  );
}

function AppLayoutWrapper() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/admin/dashboard');

  return isDashboard ? <AppRoutes /> : <><div className="app-layout"><AppRoutes /></div><Footer /></>;
}

export default App;
